import { useState } from 'react';

import CustomerDashboard from '../custom/CustomerDashboard'
export default function CustomerPage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="CustomerPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <div className="">
                    <CustomerDashboard/>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
